export default __webpack_public_path__ + "static/media/add-circle-outline.1e4409d6.svg";